// extracted by mini-css-extract-plugin
export var leftAlign = "_k-2";
export var popper = "_k-0";
export var subtitle = "_k-1";